/**
 * ADDE — Maxfiylik siyosati (uz / ru / en)
 * URL: https://addegroup.uz/privacy/{uz|ru|en}
 */

const effectiveDate = '2026-05-20';

export const privacyPolicy = {
  uz: {
    title: 'Maxfiylik siyosati',
    effectiveDate,
    intro:
      'Ushbu Maxfiylik siyosati ADDE platformasi (veb-sayt, mobil ilova va bog‘langan xizmatlar) foydalanuvchilarning shaxsiy ma’lumotlarini qanday to‘plash, ishlatish, saqlash va himoya qilish tartibini belgilaydi.',
    sections: [
      {
        title: '1. Atamalar',
        body: [
          '«Platforma» — adde.app domeni, ADDE mobil ilovasi (Android/iOS), admin paneli va API xizmatlari.',
          '«Operator» — Platformani taqdim etuvchi yuridik shaxs / yakka tartibdagi tadbirkor (keyingi o‘rinda «biz»).',
          '«Foydalanuvchi» — Platformadan foydalanuvchi jismoniy yoki yuridik shaxs vakili (mijoz, kassir, menejer va boshqalar).',
          '«Shaxsiy ma’lumot» — O‘zbekiston Respublikasi qonunchiligiga muvofiq aniqlangan shaxsga tegishli ma’lumotlar.',
        ],
      },
      {
        title: '2. Qaysi ma’lumotlarni to‘playmiz',
        body: [
          'Ro‘yxatdan o‘tish va kirish: telefon raqami, ism, rol, SMS tasdiqlash kodi (vaqtinchalik), parol (xeshlangan ko‘rinishda).',
          'Biznes ma’lumotlari: tashkilot nomi, manzil, filial, buyurtmalar, mahsulotlar, ombor, moliyaviy operatsiyalar, cheklar va hisobotlar — faqat xizmat ko‘rsatish doirasida.',
          'Texnik ma’lumotlar: IP-manzil, brauzer/ilova versiyasi, qurilma turi, sessiya identifikatorlari, xatolik jurnallari.',
          'To‘lovlar: obuna to‘lovi Click yoki Payme orqali amalga oshirilganda tranzaksiya identifikatorlari; bank kartasi raqamlari Platforma serverlarida saqlanmaydi.',
          'Ixtiyoriy: qo‘llab-quvvatlash chatidagi xabarlar, yuklangan rasmlar, bildirishnoma tokenlari (push).',
        ],
      },
      {
        title: '3. Ma’lumotlardan foydalanish maqsadlari',
        body: [
          'Hisob ochish, autentifikatsiya va xavfsizlik (SMS OTP, sessiya boshqaruvi).',
          'Savdo, ombor, moliya, hisobot va boshqa ERP funksiyalarini taqdim etish.',
          'Texnik qo‘llab-quvvatlash, xatoliklarni tuzatish va xizmat sifatini oshirish.',
          'Qonunchilik talablari, nizolarni hal qilish va firibgarlikning oldini olish.',
          'Foydalanuvchi roziligi bilan marketing xabarlari (agar alohida yoqilgan bo‘lsa).',
        ],
      },
      {
        title: '4. Huquqiy asos',
        body: [
          'O‘zbekiston Respublikasining «Shaxsga doir ma’lumotlar to‘g‘risida»gi Qonuni va boshqa amaldagi normativ hujjatlar.',
          'Foydalanuvchi bilan tuzilgan ommaviy oferta va xizmat ko‘rsatish shartnomasi.',
          'Platformadan foydalanishda berilgan rozilik (SMS kodini tasdiqlash, ofertani qabul qilish).',
        ],
      },
      {
        title: '5. Saqlash muddati va joylashuvi',
        body: [
          'Ma’lumotlar xizmat ko‘rsatish davomida va qonunchilikda belgilangan muddatlar davomida saqlanadi.',
          'Hisob yopilganda yoki so‘rov bo‘yicha ma’lumotlar o‘chirish yoki anonimlashtirish amalga oshiriladi (qonunda saqlash majburiyati bo‘lmagan hollarda).',
          'Serverlar O‘zbekiston yoki xizmat ko‘rsatuvchi hosting provayderi infratuzilmasida joylashishi mumkin; transchegaraviy uzatish bo‘lsa, tegishli himoya choralari qo‘llanadi.',
        ],
      },
      {
        title: '6. Uchinchi shaxslarga uzatish',
        body: [
          'SMS provayderi (masalan, Eskiz) — faqat tasdiqlash kodini yuborish uchun telefon raqami.',
          'To‘lov provayderlari (Click, Payme) — to‘lovni qayta ishlash uchun.',
          'Bulut hosting, monitoring va zaxira nusxa xizmatlari — shartnoma asosida va maxfiylik majburiyatlari bilan.',
          'Davlat organlarining qonuniy talabi bo‘yicha so‘rovlari.',
          'Ma’lumotlar reklama maqsadida sotilmaydi va uchinchi shaxslarga ijaraga berilmaydi.',
        ],
      },
      {
        title: '7. Xavfsizlik',
        body: [
          'HTTPS shifrlash, parollarni xeshlash, kirish tokenlarining muddati, rollar bo‘yicha ruxsatlar (RBAC).',
          'Ichki kirish cheklovlari, jurnal yuritish va muntazam yangilanishlar.',
          'Mutlaq xavfsizlik kafolatlanmaydi; foydalanuvchi ham parolini va qurilmasini himoya qilishi lozim.',
        ],
      },
      {
        title: '8. Foydalanuvchi huquqlari',
        body: [
          'O‘z ma’lumotlariga kirish, tuzatish yoki yangilash so‘rovi yuborish.',
          'Rozilikni qaytarib olish va hisobni yopish (qo‘llab-quvvatlash orqali).',
          'Noto‘g‘ri qayta ishlash bo‘yicha Operatorga yoki vakolatli organga murojaat qilish.',
          'So‘rovlar uchun: info@adde.app',
        ],
      },
      {
        title: '9. Voyaga yetmaganlar',
        body: [
          'Platforma 18 yoshdan kichik shaxslarga mo‘ljallanmagan. Voyaga yetmaganlar ma’lumoti aniqlansa, o‘chirish chorasi ko‘riladi.',
        ],
      },
      {
        title: '10. Cookie va mahalliy saqlash',
        body: [
          'Veb-sayt autentifikatsiya, til tanlovi va sessiya uchun cookie yoki localStorage dan foydalanishi mumkin.',
          'Brauzer sozlamalarida cookie ni cheklash mumkin; ba’zi funksiyalar ishlamasligi mumkin.',
        ],
      },
      {
        title: '11. O‘zgarishlar',
        body: [
          'Siyosat yangilanganda «Kuchga kirish sanasi» o‘zgartiriladi; muhim o‘zgarishlar Platformada e’lon qilinadi.',
          'Davom etgan foydalanish yangi tahrirni qabul qilish hisoblanadi.',
        ],
      },
      {
        title: '12. Aloqa',
        body: [
          'E-mail: info@adde.app',
          'Manzil: Toshkent shahri, Yunusobod tumani, Amir Temur ko‘chasi, 123-uy',
          'Veb: https://addegroup.uz',
        ],
      },
    ],
  },
  ru: {
    title: 'Политика конфиденциальности',
    effectiveDate,
    intro:
      'Настоящая Политика конфиденциальности описывает порядок сбора, использования, хранения и защиты персональных данных пользователей платформы ADDE (веб-сайт, мобильное приложение и связанные сервисы).',
    sections: [
      {
        title: '1. Термины',
        body: [
          '«Платформа» — домен adde.app, мобильное приложение ADDE (Android/iOS), панель администратора и API.',
          '«Оператор» — юридическое лицо / ИП, предоставляющее Платформу (далее — «мы»).',
          '«Пользователь» — физическое лицо или представитель юридического лица, использующий Платформу.',
          '«Персональные данные» — сведения, относящиеся к определённому лицу в соответствии с законодательством Республики Узбекистан.',
        ],
      },
      {
        title: '2. Какие данные мы собираем',
        body: [
          'Регистрация и вход: номер телефона, имя, роль, SMS-код подтверждения (временно), пароль (в хешированном виде).',
          'Бизнес-данные: название организации, адрес, филиалы, заказы, товары, склад, финансовые операции, чеки и отчёты — в рамках оказания услуг.',
          'Технические данные: IP-адрес, версия браузера/приложения, тип устройства, идентификаторы сессий, журналы ошибок.',
          'Платежи: при оплате подписки через Click или Payme — идентификаторы транзакций; номера банковских карт на серверах Платформы не хранятся.',
          'Добровольно: сообщения в чате поддержки, загруженные изображения, push-токены.',
        ],
      },
      {
        title: '3. Цели обработки',
        body: [
          'Создание учётной записи, аутентификация и безопасность (SMS OTP, управление сессиями).',
          'Предоставление функций ERP: продажи, склад, финансы, отчёты и др.',
          'Техническая поддержка, исправление ошибок и улучшение качества сервиса.',
          'Соблюдение законодательства, разрешение споров и предотвращение мошенничества.',
          'Маркетинговые сообщения — только при отдельном согласии пользователя.',
        ],
      },
      {
        title: '4. Правовые основания',
        body: [
          'Закон Республики Узбекистан «О персональных данных» и иные нормативные акты.',
          'Публичная оферта и договор оказания услуг с Пользователем.',
          'Согласие Пользователя (подтверждение SMS-кода, принятие оферты).',
        ],
      },
      {
        title: '5. Срок и место хранения',
        body: [
          'Данные хранятся в течение срока оказания услуг и сроков, установленных законом.',
          'При закрытии аккаунта или по запросу данные удаляются или обезличиваются (если нет обязанности хранения).',
          'Серверы могут располагаться в Узбекистане или у хостинг-провайдера; при трансграничной передаче применяются меры защиты.',
        ],
      },
      {
        title: '6. Передача третьим лицам',
        body: [
          'SMS-провайдер (например, Eskiz) — только для отправки кода подтверждения.',
          'Платёжные провайдеры (Click, Payme) — для обработки платежа.',
          'Облачный хостинг, мониторинг и резервное копирование — по договору с обязательствами конфиденциальности.',
          'Государственные органы — по законному запросу.',
          'Данные не продаются и не сдаются в аренду третьим лицам в рекламных целях.',
        ],
      },
      {
        title: '7. Безопасность',
        body: [
          'Шифрование HTTPS, хеширование паролей, срок действия токенов, ролевой доступ (RBAC).',
          'Ограничение внутреннего доступа, журналирование и регулярные обновления.',
          'Абсолютная безопасность не гарантируется; Пользователь обязан защищать пароль и устройство.',
        ],
      },
      {
        title: '8. Права пользователя',
        body: [
          'Запросить доступ, исправление или обновление своих данных.',
          'Отозвать согласие и закрыть учётную запись (через поддержку).',
          'Обратиться к Оператору или уполномоченному органу при нарушении обработки.',
          'Запросы: info@adde.app',
        ],
      },
      {
        title: '9. Несовершеннолетние',
        body: [
          'Платформа не предназначена для лиц младше 18 лет. При выявлении таких данных они будут удалены.',
        ],
      },
      {
        title: '10. Cookie и локальное хранилище',
        body: [
          'Сайт может использовать cookie или localStorage для аутентификации, языка и сессии.',
          'Ограничение cookie в браузере может повлиять на работу отдельных функций.',
        ],
      },
      {
        title: '11. Изменения',
        body: [
          'При обновлении Политики меняется дата вступления в силу; существенные изменения публикуются на Платформе.',
          'Продолжение использования означает принятие новой редакции.',
        ],
      },
      {
        title: '12. Контакты',
        body: [
          'E-mail: info@adde.app',
          'Адрес: г. Ташкент, Юнусабадский район, ул. Амира Темура, д. 123',
          'Сайт: https://addegroup.uz',
        ],
      },
    ],
  },
  en: {
    title: 'Privacy Policy',
    effectiveDate,
    intro:
      'This Privacy Policy explains how ADDE (website, mobile apps, and related services) collects, uses, stores, and protects personal data of its users.',
    sections: [
      {
        title: '1. Definitions',
        body: [
          '“Platform” means adde.app, the ADDE mobile application (Android/iOS), admin panel, and APIs.',
          '“Operator” means the legal entity / sole proprietor providing the Platform (“we”).',
          '“User” means an individual or representative of a business entity using the Platform.',
          '“Personal data” means information relating to an identified person under applicable law in Uzbekistan.',
        ],
      },
      {
        title: '2. Data we collect',
        body: [
          'Account and login: phone number, name, role, SMS verification code (temporary), password (hashed).',
          'Business data: company name, address, branches, orders, products, inventory, financial operations, receipts, and reports — as needed to provide the service.',
          'Technical data: IP address, browser/app version, device type, session identifiers, error logs.',
          'Payments: when paying subscription via Click or Payme — transaction identifiers; card numbers are not stored on Platform servers.',
          'Optional: support chat messages, uploaded images, push notification tokens.',
        ],
      },
      {
        title: '3. Purposes of processing',
        body: [
          'Account creation, authentication, and security (SMS OTP, session management).',
          'Providing ERP features: sales, warehouse, finance, analytics, and related tools.',
          'Technical support, bug fixes, and service improvement.',
          'Legal compliance, dispute resolution, and fraud prevention.',
          'Marketing communications only with separate user consent.',
        ],
      },
      {
        title: '4. Legal basis',
        body: [
          'Law of the Republic of Uzbekistan “On Personal Data” and other applicable regulations.',
          'Public offer and service agreement with the User.',
          'User consent (SMS confirmation, acceptance of the offer).',
        ],
      },
      {
        title: '5. Retention and location',
        body: [
          'Data is retained for the service period and as required by law.',
          'On account closure or request, data is deleted or anonymized where no legal retention duty exists.',
          'Servers may be located in Uzbekistan or with hosting providers; cross-border transfers use appropriate safeguards.',
        ],
      },
      {
        title: '6. Third parties',
        body: [
          'SMS provider (e.g. Eskiz) — phone number only to deliver verification codes.',
          'Payment providers (Click, Payme) — to process payments.',
          'Cloud hosting, monitoring, and backups — under confidentiality obligations.',
          'Government authorities — upon lawful request.',
          'We do not sell or rent personal data for advertising.',
        ],
      },
      {
        title: '7. Security',
        body: [
          'HTTPS encryption, password hashing, token expiry, role-based access (RBAC).',
          'Internal access controls, logging, and regular updates.',
          'Absolute security cannot be guaranteed; users must protect credentials and devices.',
        ],
      },
      {
        title: '8. Your rights',
        body: [
          'Request access, correction, or update of your data.',
          'Withdraw consent and close your account (via support).',
          'Contact the Operator or competent authority if processing is unlawful.',
          'Requests: info@adde.app',
        ],
      },
      {
        title: '9. Minors',
        body: [
          'The Platform is not intended for users under 18. Such data will be removed if discovered.',
        ],
      },
      {
        title: '10. Cookies and local storage',
        body: [
          'The website may use cookies or localStorage for authentication, language, and sessions.',
          'Restricting cookies may limit some features.',
        ],
      },
      {
        title: '11. Changes',
        body: [
          'We update the effective date when this Policy changes; material updates are announced on the Platform.',
          'Continued use constitutes acceptance of the revised Policy.',
        ],
      },
      {
        title: '12. Contact',
        body: [
          'Email: info@adde.app',
          'Address: Tashkent city, Yunusabad district, Amir Temur street, building 123',
          'Website: https://addegroup.uz',
        ],
      },
    ],
  },
};
